import { createFileRoute, redirect } from "@tanstack/react-router";
import App from "@/App";

export const Route = createFileRoute("/app")({
  beforeLoad: ({ location }) => {
    // Redirect /app to /app/account/dashboard
    if (location.pathname === "/app" || location.pathname === "/app/") {
      throw redirect({
        to: "/app/account/dashboard",
      });
    }
  },
  component: App,
});
